import { activityIdStorage, store } from '@/store'
import { Modal, Toast } from '@seiue/ui'
import { ReflectionRoleEnum, zeusApi } from 'packages/sdks-next/growp'
import { getUrlParams } from 'packages/utils'

/**
 * 验证 url 参数
 *
 * @returns 是否验证通过
 */
export const validUrlParams = async () => {
  const param = getUrlParams('param', location.search)

  if (!param) return false

  const { data } = await zeusApi.loadUrlHash({ hash: param || '' })

  const activityId = store.get(activityIdStorage)

  if (!data) {
    Toast.error('登录链接已失效')
    setTimeout(() => {
      location.href = '/404'
    }, 500)
    return false
  }

  if (data?.activityId !== activityId) {
    Modal.warning({
      title: '活动信息变更',
      content: '活动信息已变更，点击「知道了」将自动刷新页面',
      onOk: () => {
        location.reload()
      },
    })
    return false
  }

  return true
}

/**
 * 获取正式用户登录后跳转路由
 *  1. 学生、教师默认跳前台；超管跳后台
 *  2. 学生无跳后台按钮
 *  3. 教师根据是否有权限增加跳后台按钮
 *
 * @param role - 用户角色
 * @returns 跳转路由
 */
export const getFormalUserJumpUrl = (role?: string | null): string => {
  if (!role || role === ReflectionRoleEnum.Shadow) {
    return '/'
  }

  return '/user/gateway'
}
